import { Grid, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, FormHelperText, InputLabel, Select, MenuItem, Divider, Button, createStyles, makeStyles, Theme } from "@material-ui/core";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { createNewDraft, getFetchingError, getProjectDetails, getProjectState, updateProjectDetails } from "../../app/reducer/project.reducer";
import { ProjectDetailsFormInputs, companyNameArr } from "../../app/utils/formData";
import { useAppSelector } from "../../app/hooks"
import React, { useEffect } from "react";
import AlertComponent from "../general/Alert"; import { getAllUsersAsync, getUser } from "../../app/reducer/auth.reducer";
import { getAllUser } from "../../app/api/auth";

// projectState(pin):"saved";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    radioGroup: {
      display: 'flex',
      flexDirection: 'row'
    },
    formControl: {
      width: '100%',
    },
    radioWrapped: {
      marginLeft: theme.spacing(2),
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }),
);

interface Customers {
  _id: string;
  name: string;
  email: string;
  userType: Number;
  isActive: boolean;
  canExport: boolean;
}

export default function ProjectDetailsForm({ setIndex }: { setIndex: Function }): JSX.Element {
  const [busy, setBusy] = React.useState<boolean>(false);
  const [openAlert, setOpenAlert] = React.useState<boolean>(false);
  const [openErrAlert, setOpenErrAlert] = React.useState<boolean>(false);
  const [customerList, setCustomerList] = React.useState<Customers[]>([]);

  const { register, formState, getValues, setValue, handleSubmit, control, formState: { errors } } = useForm<ProjectDetailsFormInputs>();
  const dispatch = useDispatch()
  const classes = useStyles();

  const projectState = useAppSelector(getProjectState);
  const projectDetails = useAppSelector(getProjectDetails);
  const fetchingErr = useAppSelector(getFetchingError);
  const user = useAppSelector(getUser);

  const createDraft = async (data: ProjectDetailsFormInputs) => {
    if (busy) return;
    await dispatch(createNewDraft(data));
    if (fetchingErr === false) {
      dispatch(updateProjectDetails(data));
      setOpenAlert(true);
    } else {
      setOpenErrAlert(true);
    }
  }

  useEffect(() => {

    if (projectDetails) {
      for (const [key, value] of Object.entries(projectDetails)) {
        // console.log(`${key}: ${value}`);
        let anykey = key as any;
        setValue(anykey, value);
      }
    }


  }, [projectDetails])

  useEffect(() => {

    if (projectState === 'new') {
      const now = new Date().getTime();
      let uid = "";
      if (user.user) uid = user.user?.username.substring(0, 2).toUpperCase();
      setValue("draft_project_number", "DR-" + uid + now.toString());
      setValue("project_number", "PR-" + uid + now.toString());
    } else {
      let projName = projectDetails.draft_project_number.split("-")[1];
      setValue("project_number", "PR-" + projName);
    }
    // projectDetails.forEach(({key, value}:{key:any, value:any}) => {
    //   setValue(key,value);
    // });
    async function getUsersHandler() {
      const resp = await getAllUser();
      console.log(resp);
      const customers = resp?.response?.data?.filter((e: any) => (user.user?.userType == 4 ||user.user?.userType == 3)  ? (e.email=== user.user?.email && (e?.userType === 4 || e?.userType === 3)):  e?.userType === 4||e.userType===3);
      if(user.user?.userType == 4 || user.user?.userType == 3) // for user type agent and customer set the default name as there own username
        setValue('customer_name',customers[0]?._id)
      console.log(customers)
      setCustomerList(customers);
    } 
    getUsersHandler();
  }, [])

  const onSubmit: SubmitHandler<ProjectDetailsFormInputs> = async data => {
    setBusy(true);
    setOpenAlert(false);
    console.log(data);
    await dispatch(updateProjectDetails(data));
    setOpenAlert(true);
    setBusy(false);
    // console.log("PROJ", data);
    setIndex(1)
  };

  return (
    <form id="fan-details-form" onSubmit={handleSubmit(onSubmit)} style={{ padding: '5px' }}>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={6}>
          {/* <TextField
              label="Customer Name" disabled={projectState!=="new"}
              {...register("customer_name")}
              variant="outlined" fullWidth
              error={(errors.customer_name?true:false)}
              helperText={errors.customer_name?'Please enter customer name':''}
            /> */}

          <FormControl variant="outlined" className={classes.formControl} error={errors.customer_name ? true : false}>
            <InputLabel style={{ fontSize: '22px' }}>Customer Name</InputLabel>
            <Controller
              control={control}
              name="customer_name" rules={{ required: true }}
              defaultValue="None"

              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  label="Encon Company Name"
                  style={{ fontSize: '15px' }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {customerList.map(el => {
                    return <MenuItem style={{ fontSize: '15px' }} key={el.name} value={el._id}>{el.name}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.company_name ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            size="medium"
            label="Consultant" disabled={projectState !== "new"}
            {...register("consultant")}
            variant="outlined" fullWidth
            error={(errors.consultant ? true : false)}
            helperText={errors.consultant ? 'This field is required' : ''}
            InputLabelProps={{
              style: { fontSize: "18px" }
            }}
          />
        </Grid>
        <Grid item xs={12} lg={12}>
          <TextField
            label="Location" disabled={projectState !== "new"}
            {...register("location")}
            variant="outlined" fullWidth
            error={(errors.location ? true : false)}
            helperText={errors.location ? 'Please enter customer name' : ''}
            InputLabelProps={{
              style: { fontSize: "18px" }
            }}
          />
        </Grid>
        <Grid item xs={12} lg={12}>
          <TextField
            label="Project" disabled={projectState !== "new"}
            {...register("project")}
            variant="outlined" fullWidth
            error={(errors.project ? true : false)}
            helperText={errors.project ? 'Please enter customer name' : ''}
            InputLabelProps={{
              style: { fontSize: "18px" }
            }}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            label="Offer Number" disabled={projectState !== "new"}
            {...register("offer_number")}
            variant="outlined" fullWidth
            error={(errors.offer_number ? true : false)}
            helperText={errors.offer_number ? 'Please enter customer name' : ''}
            InputLabelProps={{
              style: { fontSize: "18px" }
            }}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            label="PO Number" disabled={projectState !== "new"}
            {...register("po_number")}
            variant="outlined" fullWidth
            error={(errors.po_number ? true : false)}
            helperText={errors.po_number ? 'Please enter customer name' : ''}
            InputLabelProps={{
              style: { fontSize: "18px" }
            }}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <FormControl component="fieldset" error={errors.unit ? true : false} className={classes.radioWrapped}>
            <FormLabel component="legend" style={{ fontSize: "18px", fontWeight: 600 }}>
              Unit
            </FormLabel>

            <Controller
              control={control}
              name="unit"
              rules={{ required: true }}
              defaultValue="SI"
              render={({ field: { onChange, value } }) => (
                <RadioGroup
                  aria-label="unit"
                  name="unit"
                  value={value}
                  onChange={onChange}
                  className={classes.radioGroup}
                >
                  <FormControlLabel value="IP" control={<Radio disabled={true} />} label="I-P" />
                  <FormControlLabel value="SI" control={<Radio disabled={projectState !== "new"} />} label="SI" />
                </RadioGroup>
              )}
            />

            <FormHelperText>{errors.unit ? "Please specify unit" : ""}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={6}>
          <FormControl variant="outlined" className={classes.formControl} error={errors.company_name ? true : false}>
            <InputLabel style={{ fontSize: '15px' }}>Encon Company</InputLabel>
            <Controller
              control={control}
              name="company_name" rules={{ required: true }}
              defaultValue="ENCON_GROUP"
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value} disabled={projectState !== "new"}
                  onChange={onChange}
                  label="Encon Company Name"
                  style={{ fontSize: '15px' }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {companyNameArr.map(el => {
                    return <MenuItem style={{ fontSize: '15px' }} key={el.key} value={el.key}>{el.text}</MenuItem>
                  })
                  }
                </Select>
              )}
            />
            <FormHelperText>{errors.company_name ? 'This field is required' : ''}</FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12} lg={12}>
          {projectState === "saved" ?
            <TextField
              label="Project Number" disabled={true}
              {...register("project_number")}
              variant="outlined" fullWidth
              error={(errors.project_number ? true : false)}
              helperText={errors.project_number ? 'Please enter customer name' : ''}
              InputLabelProps={{
                style: { fontSize: "18px" }
              }}
            />
            :
            <TextField
              label="Draft Project Number (Automatically Generated)" disabled={true}
              {...register("draft_project_number")}
              variant="outlined" fullWidth
              error={(errors.draft_project_number ? true : false)}
              helperText={errors.draft_project_number ? 'Please enter customer name' : ''}
              InputLabelProps={{
                style: { fontSize: "18px" }
              }}
            />
          }
        </Grid>
        <Grid item xs={12} lg={12}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            size="large"
            style={{ marginLeft: '20px' }}
          // onClick={()=>{
          //   const values = getValues();
          //   dispatch(updateProjectDetails(values));
          // }}
          >
            Next
          </Button>
        </Grid>
      </Grid>
      <AlertComponent open={openAlert} message="Changes saved successfully." severity="success" handleClose={() => { setOpenAlert(false) }} />
      <AlertComponent open={openErrAlert} message="Something went wrong. Please Try again." severity="error" handleClose={() => { setOpenErrAlert(false) }} />
    </form>

  )
}